import React from 'react';
import Button from 'react-bootstrap/Button';

import { useNavigation } from '../../../common/navigation';
import { useTranslation } from '../../../common/hooks/useTranslation';

export const Landing: React.FC = () => {
  const nav = useNavigation();
  const { t, tk } = useTranslation('administrationLng');

  return (
    <div className="main-banner p-5 rounded-lg m-3">
      <div className="main-banner-text">
        <h1>POK</h1>
        <p className="lead">{t(tk.common.pok)}</p>

        <hr className="my-4" />
        <div className="btn-banner d-flex justify-content-start mt-3">
          <Button className="btn-banner" variant="outline" onClick={nav.help}>
            {t(tk.common.help)}
          </Button>
        </div>
      </div>
    </div>
  );
};
